import { DownloadIcon } from "@chakra-ui/icons";
import {
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure, useToast,
} from "@chakra-ui/react";
import {useMutation, useQueryClient} from "react-query";

import {requestResults} from "../../shared/Api";
import {errorToast, infoToast, successToast} from "../../shared/helper/ToastHelper";
import {CandidateFilterParams} from "../../shared/model/Dto";
import {adminKeys} from "../../shared/QueryKeys";
import {saveByteArray} from "../../shared/Utils";

const DownloadResults = (props: CandidateFilterParams ) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const downloadResults = useMutation(()=>
    {
      infoToast(toast, "Procesando resultados");
      return requestResults(props)
    }, {
    onSuccess: (TData) => {
      successToast(toast, "Descargando resultados");
      saveByteArray("Resultados", TData.data);
      return queryClient.invalidateQueries(adminKeys.candidateAnswers());
    },
    onError: () => {
      errorToast(toast, "Error descargando resultados");
    },
  });

  return (
      <>
        <Button leftIcon={<DownloadIcon />} colorScheme="teal" onClick={onOpen}>
          Descargar resultados
        </Button>
        <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Descargar resultados</ModalHeader>
            <ModalCloseButton />
            <ModalFooter>
              <Button
                marginX={10}
                colorScheme="teal"
                type="submit"
                onClick={()=>downloadResults.mutate()}
              >
                Descargar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
  );
};

export default DownloadResults;
